import React from 'react';
import { default as Spacer } from '../spacer';
import { ValidThemes } from '../../utils/types';

interface DotProps {
  theme: ValidThemes | 'white',
  animationDelay?: string
}

export interface LoaderProps {
  theme?: ValidThemes | 'white'
}

const getDotColorFromTheme = (theme:ValidThemes|'white') => {
  switch (theme) {
    case 'primary':
      return 'bg-accents-primary';
    case 'secondary':
      return 'bg-on-primary';
    case 'variant':
      return 'bg-on-variant';
    case 'error':
      return 'bg-on-error';
    case 'disabled':
      return 'bg-on-disabled';
    case 'white':
      return 'bg-accents-on-primary'
  }
}

const Dot = ({theme, animationDelay }:DotProps) => (
  <div
    className={`relative w-2.5 h-2.5 rounded-[50%] ${getDotColorFromTheme(theme)} animate-dot-bounce`}
    style={{ animationDelay: animationDelay}}>
  </div>
)

export const Loader = ({ 
  theme = 'primary'
}:LoaderProps) => (
  <div
    className='relative flex h-full min-h-lg justify-center align-items pt-2'>
      <Dot theme={theme} animationDelay='.2s' />
      <Spacer type="horizontal" size="sm" />
      <Dot theme={theme} animationDelay='.3s' />
      <Spacer type="horizontal" size="sm" />
      <Dot theme={theme} animationDelay='.4s' />
  </div>
);

export default Loader;
